import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=2066f1c1&lang=pug"
import script from "./CommentBlock.vue?vue&type=script&lang=ts"
export * from "./CommentBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports